import React from "react";

import { Navigate, Outlet } from "react-router-dom";
//KS: 2023-07-19 footerSectionFilteredFlag (Add)
const ProtectedRoute = ({ submenuFiltered, footerSectionFilteredFlag }) => {
  const path = window.location.pathname
  const allowedOnCareersPage = path.startsWith("/employment/") && path.replace("/employment/", "").length > 0
  return (allowedOnCareersPage || submenuFiltered.length > 0 || footerSectionFilteredFlag > 0) ? <Outlet /> : <Navigate to="/home" />;
};

export default ProtectedRoute;
